const uppdateKMs = (
  data,
  setEngineOilFilterPercent,
  setOilFilterPercent,
  setEngineFilterPercent,
  setCabinFilterPercent,
  setFuelFilterPercent,
  setSaltGlassPercent,
  setRadiatorPercent,
  setBatteryPercent

  // setInjectorPercent,
  // setBrakePadPercent,
  // setTirePercent,
  // setSparkPercent,
  // setengineWashPercent,
  // setHydraulicPercent,
  // setFlashEnginePercent,
  // setGearBoxOilPercent
) => {
  for (let i = 0; i < Object.entries(data["percent-short"]).length; i++) {
    switch (data["percent-short"][i]["pieceName"]) {
      case "oil-motor":
        setEngineOilFilterPercent(data["percent-short"][i]["percent"]);
        break;
      case "oil-filter":
        setOilFilterPercent(data["percent-short"][i]["percent"]);
        break;
      case "filter-motor":
        setEngineFilterPercent(data["percent-short"][i]["percent"]);
        break;
      case "filter-room":
        setCabinFilterPercent(data["percent-short"][i]["percent"]);
        break;
      case "filter-petrol":
        setFuelFilterPercent(data["percent-short"][i]["percent"]);
        break;
      case "glassCleaner":
        setSaltGlassPercent(data["percent-short"][i]["percent"]);
        break;
      case "radiatorWater":
        setRadiatorPercent(data["percent-short"][i]["percent"]);
        break;
      case "battery":
        setBatteryPercent(data["percent-short"][i]["percent"]);
        break;
    }
  }
};
export default uppdateKMs;
